import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import Button from 'components/common/Button';

class CookiesBar extends Component {
  constructor(props) {
    super(props);
    this.setCookiesBarRef = this.setCookiesBarRef.bind(this);
  }

  componentDidMount() {
    this.props.updateContainerTopPadding(this.cookieBarRef.offsetHeight);
  }

  setCookiesBarRef(node) {
    this.cookieBarRef = node;
  }

  render() {
    return (
      <div className="cookies-bar" ref={this.setCookiesBarRef}>
        <div className="container">
          <div className="cookies-bar__content">
            <p className="cookies-bar__text">
              <FormattedHTMLMessage id="cookies_bar.content" />
            </p>
            <div className="cookies-bar__btn-close">
              <Button btnSize="small" btnType="third" onClick={this.props.onClose}>
                <FormattedMessage id="cookies_bar.agree" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CookiesBar.propTypes = {
  onClose: PropTypes.func,
  updateContainerTopPadding: PropTypes.func,
};

export default CookiesBar;
